import { render, staticRenderFns } from "./ShowPermissionsDialog.vue?vue&type=template&id=48109ea3&scoped=true&"
import script from "./ShowPermissionsDialog.vue?vue&type=script&lang=ts&"
export * from "./ShowPermissionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShowPermissionsDialog.vue?vue&type=style&index=0&id=48109ea3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48109ea3",
  null
  
)

export default component.exports